//Node Modules
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

//BinaryForge Components
import { BfDialog } from "../helpers";
import { Note } from "../helpers";

//3rd Party Components
import { Button } from "primereact/button";

//Atoms
import { dialogAtomFamily } from "../../atoms";

//Helpers

//Other

const DupeUserDialog = ({ email }) => {
	//Hooks
	const { t } = useTranslation();

	// Recoil
	const setShow = useSetRecoilState(dialogAtomFamily("dupeUserDialog"));

	// Footer
	const footer = (
		<>
			<Button label={t("common.action.ok")} onClick={() => setShow(false)} />
		</>
	);

	return (
		<BfDialog id="dupeUserDialog" header={t("admin.user.dupeStandard.dialog.header")} footer={footer}>
			<Note
				messageKey={t("admin.user.dupeStandard.dialog.message", { email })}
				icon="pi-exclamation-circle fontColour-error"
			/>
		</BfDialog>
	);
};

export default DupeUserDialog;
